import React from "react";
import styled from "styled-components";
import { useCurrentProfile, useRegisterState } from "@domain/currentProfile/hooks";
import { RegisterState } from "@domain/currentProfile/registerState";
import { EmailVerify } from "./emailVerify";
import { ProfileNames } from "./profileNames";
import { ProfileRoleStep } from "./profileRole";

type OnboardingProps = React.HTMLAttributes<HTMLDivElement>;

export const Onboarding: React.FC<OnboardingProps> = ({ ...htmlProps }) => {
	const state = useRegisterState();
	const currentProfile = useCurrentProfile();

	if (state === RegisterState.VERIFY) {
		return <EmailVerify profile={currentProfile} {...htmlProps} />;
	}

	if (state === RegisterState.INFOS) {
		return <ProfileNames />;
	}

	if (state === RegisterState.ROLE && currentProfile) {
		return <ProfileRoleStep {...htmlProps} />;
	}
	return <Container {...htmlProps} />;
};

const Container = styled.div``;
